export default __webpack_public_path__ + "2be4cd77dc4829e1a6d43bbdc2c55ee7.png";